var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form",
        {
          attrs: {
            form: _vm.form,
            "label-col": { span: 12 },
            "wrapper-col": { span: 12 },
          },
        },
        [
          _c("div", { staticClass: "form_title" }, [_vm._v("创建海报")]),
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              { staticClass: "bg", attrs: { id: "poster" } },
              [
                _c("img", {
                  ref: "imgHeight",
                  staticClass: "bg-img",
                  attrs: {
                    src: _vm.api.temp.FILE_PATH + _vm.posterBackgroundImg,
                    alt: "",
                  },
                }),
                _vm.isHeadImg
                  ? _c(
                      "VueDragResize",
                      {
                        ref: "VueDragResize",
                        attrs: {
                          isActive: true,
                          w: _vm.hd.width,
                          h: _vm.hd.height,
                          x: _vm.hd.xaxis,
                          y: _vm.hd.yaxis,
                          parentW: 375,
                          parentH: _vm.parentH,
                          parentLimitation: true,
                        },
                        on: { resizing: _vm.resize, dragging: _vm.resize },
                      },
                      [
                        _c("a-avatar", {
                          staticClass: "hd",
                          attrs: { src: require("@/assets/img/moren.png") },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.isName
                  ? _c(
                      "VueDragResize",
                      {
                        ref: "VueDragResize1",
                        attrs: {
                          isActive: true,
                          w: _vm.name.width,
                          h: _vm.name.height,
                          x: _vm.name.xaxis,
                          y: _vm.name.yaxis,
                          parentW: 375,
                          parentH: _vm.parentH,
                          parentLimitation: true,
                        },
                        on: { resizing: _vm.resize2, dragging: _vm.resize2 },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "name",
                            style: {
                              color: _vm.sizeColor,
                              fontSize: _vm.staffNameSize + "px",
                            },
                          },
                          [_vm._v("员工昵称")]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.isQrcode
                  ? _c(
                      "VueDragResize",
                      {
                        ref: "VueDragResize2",
                        attrs: {
                          isActive: true,
                          w: _vm.ewm.width,
                          h: _vm.ewm.height,
                          x: _vm.ewm.xaxis,
                          y: _vm.ewm.yaxis,
                          parentW: 375,
                          parentH: _vm.parentH,
                          parentLimitation: true,
                        },
                        on: { resizing: _vm.resize1, dragging: _vm.resize1 },
                      },
                      [
                        _c("img", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            src: require("@/assets/img/ewm.jpg"),
                            alt: "",
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form" },
              [
                _c(
                  "a-spin",
                  { attrs: { spinning: _vm.formOption.busy } },
                  [
                    _c(
                      "a-form",
                      {
                        attrs: {
                          form: _vm.form,
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 12 },
                        },
                      },
                      [
                        _c(
                          "a-form-item",
                          { attrs: { label: "海报标题" } },
                          [
                            _c("a-input", {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: ["title", _vm.rules.title],
                                  expression: "['title', rules.title]",
                                },
                              ],
                              attrs: {
                                maxLength: 20,
                                placeholder: "请输入海报标题",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "a-row",
                          { attrs: { gutter: 24 } },
                          [
                            _c(
                              "a-form-item",
                              { attrs: { label: "分类" } },
                              [
                                _c("a-tree-select", {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: ["carTypeId", _vm.rules.carTypeId],
                                      expression:
                                        "['carTypeId',rules.carTypeId]",
                                    },
                                  ],
                                  attrs: {
                                    "allow-clear": "",
                                    "dropdown-style": {
                                      maxHeight: "300px",
                                      overflow: "auto",
                                    },
                                    placeholder: "请选择分类",
                                    treeData: _vm.treeData,
                                    replaceFields: {
                                      children: "children",
                                      title: "codeName",
                                      key: "codeId",
                                      value: "codeId",
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "item" },
                  [
                    _c("span", [_vm._v("*")]),
                    _vm._v(" 上传海报背景图 : "),
                    _c("uploader", {
                      attrs: {
                        num: 1,
                        accept: "image/*",
                        url: _vm.api.temp.UPLOAD_PATH,
                      },
                      model: {
                        value: _vm.posterBackgroundImg,
                        callback: function ($$v) {
                          _vm.posterBackgroundImg = $$v
                        },
                        expression: "posterBackgroundImg",
                      },
                    }),
                    _vm._v(
                      " 只能上传jpg、jpeg、png文件，建议尺寸：750px*1280px，不超过5M "
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "keys" }, [
                  _c("p", [_vm._v("展示字段")]),
                  _c("ul", [
                    _c(
                      "li",
                      [
                        _vm._v("员工二维码 "),
                        _c("a-switch", {
                          model: {
                            value: _vm.isQrcode,
                            callback: function ($$v) {
                              _vm.isQrcode = $$v
                            },
                            expression: "isQrcode",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "li",
                      [
                        _vm._v("员工头像 "),
                        _c("a-switch", {
                          model: {
                            value: _vm.isHeadImg,
                            callback: function ($$v) {
                              _vm.isHeadImg = $$v
                            },
                            expression: "isHeadImg",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "li",
                      [
                        _vm._v("员工昵称 "),
                        _c("a-switch", {
                          model: {
                            value: _vm.isName,
                            callback: function ($$v) {
                              _vm.isName = $$v
                            },
                            expression: "isName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "li",
                      [
                        _vm._v("昵称颜色 "),
                        _c("colorPicker", {
                          staticStyle: { border: "1px solid #000" },
                          model: {
                            value: _vm.sizeColor,
                            callback: function ($$v) {
                              _vm.sizeColor = $$v
                            },
                            expression: "sizeColor",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "li",
                      [
                        _vm._v(" 文字大小 "),
                        _c(
                          "a-radio-group",
                          {
                            model: {
                              value: _vm.staffNameSize,
                              callback: function ($$v) {
                                _vm.staffNameSize = $$v
                              },
                              expression: "staffNameSize",
                            },
                          },
                          [
                            _c("a-radio-button", { attrs: { value: 16 } }, [
                              _vm._v(" 小 "),
                            ]),
                            _c("a-radio-button", { attrs: { value: 20 } }, [
                              _vm._v(" 中 "),
                            ]),
                            _c("a-radio-button", { attrs: { value: 24 } }, [
                              _vm._v(" 大 "),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
                _c("div", [
                  _vm._v(
                    " 海报上的展示字段可拖动调整位置，点击后拖动边框调整大小 "
                  ),
                ]),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c(
            "a-button",
            {
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm._save(false)
                },
              },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }